/**
 * 默认数据，用函数return
 */
import type {
  userInfoInterface,
  countryInterface,
  levelExperienceInterface
} from '@/types/apiType/userType'
import type { roomInfoInterface } from '@/types/apiType/roomType'
import type {
  queueInterface,
  rtcInfoInterface
} from '@/types/viewsType/socketType'

/** rtcInfo,socket返回的rtc数据 */
function defaultRtcInfo(): rtcInfoInterface {
  return {
    appId: '',
    channel: '',
    hasPush: false,
    privateMapKey: '',
    rtcType: '',
    token: '',
    uid: ''
  }
}

/** 用户等级经验 */
function defaultLevelExperienceInfo(): levelExperienceInterface {
  return {
    uid: 0,
    avatar: '',
    levelSeq: 0,
    levelName: '', // 等级
    levelPercent: 0, // 金币等级百分比
    leftGoldNum: 0, // 升到下一级所需的金币数量
    levelPic: '', // 等级图片
    levelRewardActSwitch: true, // 财富等级活动开关 预留
    levelRewardActUrl: '', // 财富等级活动Url
    erbanNo: 0,
    nick: ''
  }
}

/** 用户信息 */
function defaultUserInfo(): userInfoInterface {
  return {
    uid: 0,
    erbanNo: 0,
    nick: '',
    gender: 0,
    avatar: '',
    userDesc: '',
    bestFriendNum: 0,
    followNum: 0,
    fansNum: 0,
    birth: 0,
    diamondNum: 0,
    language: {
      firstLanguage: '',
      secondLanguage: '',
      language: 0
    },
    country: '',
    countryInfo: {
      countryId: 0,
      countryName: '',
      countryNameAr: '',
      countryNameCn: '',
      countryNameVi: '',
      countryNameIn: '',
      countryNameEs: '',
      countryNameTw: '',
      countryNamePt: '',
      countryNameTh: '',
      countryCode: '',
      countryShort: '',
      countryIcon: '',
      circularIcon: '',
      countryLanguage: 0,
      continent: 0,
      sort: 0
    },
    freeCall: false,
    callDiamond: 0,
    isFans: false,
    agoraKey: '',
    liveRoomId: '',
    privatePhoto: [],
    isFirstCharge: false,
    userState: 0,
    videoRoomExperLevel: 0,
    videoRoomExperLevelPic: '',
    charmLevel: 0,
    charmLevelPic: '',
    redbeanNum: 0,
    callPrice: 0,
    gid: 0,
    createTime: 0
  }
}

/** 房间信息 */
function defaultRoomInfo(): roomInfoInterface {
  return {
    roomId: 0,
    uid: 0,
    nick: '',
    avatar: '',
    type: 0,
    videoChannel: 2
  }
}

/** 默认国家信息 */
function defaultCountryData(): countryInterface {
  return {
    countryId: 0,
    countryName: '',
    countryNameAr: '',
    countryNameCn: '',
    countryNameVi: '',
    countryNameIn: '',
    countryNameEs: '',
    countryNameTw: '',
    countryNamePt: '',
    countryNameTh: '',
    countryCode: '',
    countryShort: '', //国家编码 传参需要传入这个
    countryIcon: '',
    circularIcon: '',
    countryLanguage: 0,
    continent: 0,
    sort: 0
  }
}

/** 默认麦位列表 */
function defaultQueueList(): queueInterface[] {
  return [
    {
      key: 0,
      value: {
        mic_info: {
          position: 0,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 1,
      value: {
        mic_info: {
          position: 1,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 2,
      value: {
        mic_info: {
          position: 2,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 3,
      value: {
        mic_info: {
          position: 3,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 4,
      value: {
        mic_info: {
          position: 4,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 5,
      value: {
        mic_info: {
          position: 5,
          posState: 0,
          micState: 0,
          mediaType: 1,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 6,
      value: {
        mic_info: {
          position: 6,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 7,
      value: {
        mic_info: {
          position: 7,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 8,
      value: {
        mic_info: {
          position: 8,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 9,
      value: {
        mic_info: {
          position: 9,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    },
    {
      key: 10,
      value: {
        mic_info: {
          position: 10,
          posState: 0,
          micState: 0,
          mediaType: 0,
          isBackground: 0
        },
        member: null,
        on_mic_type: 0
      }
    }
  ]
}

export default {
  defaultRtcInfo,
  defaultLevelExperienceInfo,
  defaultUserInfo,
  defaultRoomInfo,
  defaultCountryData,
  defaultQueueList
}
